import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center pt-40 mx-5 text-sm font-medium" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.join_retro')
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useStore } from 'vuex';
import moment from 'moment';
import { useRetroStore } from '@/pinia_stores/retro';
import constants from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'JoinRetro',
    setup(__props) {
        const store = useStore();
        const retroStore = useRetroStore();
        const { isFull, phase, startsAt, callLink } = storeToRefs(retroStore);
        const session = computed(() => store.getters.session);
        const tooEarly = computed(() => {
            return moment(startsAt.value).diff(moment(), 'hours') > constants.EARLY_JOINING_THRESHOLD;
        });
        function handleJoin() {
            // This was the `joinRetro` vuex retro store action.
        }
        return (_ctx, _cache) => {
            const _component_section_heading = _resolveComponent("section-heading");
            const _component_paragraph = _resolveComponent("paragraph");
            const _component_pill_button = _resolveComponent("pill-button");
            const _component_external_link = _resolveComponent("external-link");
            const _component_i18n_t = _resolveComponent("i18n-t");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_section_heading, {
                    truncate: true,
                    heading: _ctx.$t('welcome', { name: _unref(session).name })
                }, null, 8, ["heading"]),
                (_unref(phase) !== 'setup')
                    ? (_openBlock(), _createBlock(_component_paragraph, { key: 0 }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('already_started')), 1)
                        ], undefined, true),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (!_unref(isFull))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_pill_button, {
                            class: "my-10",
                            onClick: handleJoin
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('join')), 1)
                            ], undefined, true),
                            _: 1
                        }),
                        _createVNode(_component_paragraph, null, {
                            default: _withCtx(() => [
                                (!_unref(tooEarly))
                                    ? (_openBlock(), _createBlock(_component_i18n_t, {
                                        key: 0,
                                        keypath: "join_call.text"
                                    }, {
                                        default: _withCtx(() => [
                                            (_unref(callLink))
                                                ? (_openBlock(), _createBlock(_component_external_link, {
                                                    key: 0,
                                                    href: _unref(callLink),
                                                    text: _ctx.$t('join_call.link')
                                                }, null, 8, ["href", "text"]))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('join_call.link')), 1)
                                                ], 64))
                                        ], undefined, true),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 1
                        })
                    ], 64))
                    : (_openBlock(), _createBlock(_component_paragraph, { key: 2 }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('no_slots')), 1)
                        ], undefined, true),
                        _: 1
                    }))
            ]));
        };
    }
});
